import React, { useEffect, useState } from "react";

function LoadingPage() {
  const [showTagline, setShowTagline] = useState(false);
  const [showSubtitle, setShowSubtitle] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShowTagline(true), 1800);
    const t2 = setTimeout(() => setShowSubtitle(true), 2200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  return (
    <div className="loading">
      <div className="particles-container">
        {Array.from({ length: 40 }).map((_, i) => (
          <div key={i} className="particle" style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 4}s`,
            animationDuration: `${3 + Math.random() * 4}s`,
            width: `${1 + Math.random() * 3}px`,
            height: `${1 + Math.random() * 3}px`,
            opacity: 0.1 + Math.random() * 0.5,
          }} />
        ))}
      </div>

      <div className="loading-content">
        <div className="logo-wrapper">
          <div className="glow-ring" />
          <svg
            id="logo"
            width="600"
            height="120"
            viewBox="570 486 310 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <filter id="glow">
                <feGaussianBlur stdDeviation="2.5" result="coloredBlur" />
                <feMerge>
                  <feMergeNode in="coloredBlur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <path
              filter="url(#glow)"
              d="M610.464 501.12C609.072 498.192 607.056 495.936 604.416 494.352C601.776 492.72 598.704 491.904 595.2 491.904C591.696 491.904 588.528 492.72 585.696 494.352C582.912 495.936 580.704 498.24 579.072 501.264C577.488 504.24 576.696 507.696 576.696 511.632C576.696 515.568 577.488 519.024 579.072 522C580.704 524.976 582.912 527.28 585.696 528.912C588.528 530.496 591.696 531.288 595.2 531.288C600.096 531.288 604.128 529.824 607.296 526.896C610.464 523.968 612.312 520.008 612.84 515.016H592.824V509.688H619.824V514.728C619.44 518.856 618.144 522.648 615.936 526.104C613.728 529.512 610.824 532.224 607.224 534.24C603.624 536.208 599.616 537.192 595.2 537.192C590.544 537.192 586.296 536.112 582.456 533.952C578.616 531.744 575.568 528.696 573.312 524.808C571.104 520.92 570 516.528 570 511.632C570 506.736 571.104 502.344 573.312 498.456C575.568 494.52 578.616 491.472 582.456 489.312C586.296 487.104 590.544 486 595.2 486C600.528 486 605.232 487.32 609.312 489.96C613.44 492.6 616.44 496.32 618.312 501.12H610.464Z"
              stroke="#63FFCD"
              strokeWidth="1.8"
            />
            <path
              filter="url(#glow)"
              d="M645.695 537.408C641.999 537.408 638.639 536.568 635.615 534.888C632.639 533.208 630.287 530.832 628.559 527.76C626.879 524.64 626.039 521.04 626.039 516.96C626.039 512.928 626.903 509.376 628.631 506.304C630.407 503.184 632.807 500.808 635.831 499.176C638.855 497.496 642.239 496.656 645.983 496.656C649.727 496.656 653.111 497.496 656.135 499.176C659.159 500.808 661.535 503.16 663.263 506.232C665.039 509.304 665.927 512.88 665.927 516.96C665.927 521.04 665.015 524.64 663.191 527.76C661.415 530.832 658.991 533.208 655.919 534.888C652.847 536.568 649.439 537.408 645.695 537.408ZM645.695 531.648C648.047 531.648 650.255 531.096 652.319 529.992C654.383 528.888 656.039 527.232 657.287 525.024C658.583 522.816 659.231 520.128 659.231 516.96C659.231 513.792 658.607 511.104 657.359 508.896C656.111 506.688 654.479 505.056 652.463 504C650.447 502.896 648.263 502.344 645.911 502.344C643.511 502.344 641.303 502.896 639.287 504C637.319 505.056 635.735 506.688 634.535 508.896C633.335 511.104 632.735 513.792 632.735 516.96C632.735 520.176 633.311 522.888 634.463 525.096C635.663 527.304 637.247 528.96 639.215 530.064C641.183 531.12 643.343 531.648 645.695 531.648Z"
              stroke="#63FFCD"
              strokeWidth="1.8"
            />
            <path
              filter="url(#glow)"
              d="M737.614 486.576L723.07 536.76H715.726L704.062 496.368L691.966 536.76L684.694 536.832L670.654 486.576H677.638L688.582 529.128L700.678 486.576H708.022L719.542 528.984L730.558 486.576H737.614Z"
              stroke="#63FFCD"
              strokeWidth="1.8"
            />
            <path
              filter="url(#glow)"
              d="M742.336 516.888C742.336 512.856 743.152 509.328 744.784 506.304C746.416 503.232 748.648 500.856 751.48 499.176C754.36 497.496 757.552 496.656 761.056 496.656C764.512 496.656 767.512 497.4 770.056 498.888C772.6 500.376 774.496 502.248 775.744 504.504V497.304H782.368V536.76H775.744V529.416C774.448 531.72 772.504 533.64 769.912 535.176C767.368 536.664 764.392 537.408 760.984 537.408C757.48 537.408 754.312 536.544 751.48 534.816C748.648 533.088 746.416 530.664 744.784 527.544C743.152 524.424 742.336 520.872 742.336 516.888ZM775.744 516.96C775.744 513.984 775.144 511.392 773.944 509.184C772.744 506.976 771.112 505.296 769.048 504.144C767.032 502.944 764.8 502.344 762.352 502.344C759.904 502.344 757.672 502.92 755.656 504.072C753.64 505.224 752.032 506.904 750.832 509.112C749.632 511.32 749.032 513.912 749.032 516.888C749.032 519.912 749.632 522.552 750.832 524.808C752.032 527.016 753.64 528.72 755.656 529.92C757.672 531.072 759.904 531.648 762.352 531.648C764.8 531.648 767.032 531.072 769.048 529.92C771.112 528.72 772.744 527.016 773.944 524.808C775.144 522.552 775.744 519.936 775.744 516.96Z"
              stroke="#63FFCD"
              strokeWidth="1.8"
            />
            <path
              filter="url(#glow)"
              d="M808.128 530.712L820.368 497.304H827.352L811.872 536.76H804.24L788.76 497.304H795.816L808.128 530.712Z"
              stroke="#63FFCD"
              strokeWidth="1.8"
            />
            <path
              filter="url(#glow)"
              d="M869.8 515.52C869.8 516.768 869.728 518.088 869.584 519.48H838.048C838.288 523.368 839.608 526.416 842.008 528.624C844.456 530.784 847.408 531.864 850.864 531.864C853.696 531.864 856.048 531.216 857.92 529.92C859.84 528.576 861.184 526.8 861.952 524.592H869.008C867.952 528.384 865.84 531.48 862.672 533.88C859.504 536.232 855.568 537.408 850.864 537.408C847.12 537.408 843.76 536.568 840.784 534.888C837.856 533.208 835.552 530.832 833.872 527.76C832.192 524.64 831.352 521.04 831.352 516.96C831.352 512.88 832.168 509.304 833.8 506.232C835.432 503.16 837.712 500.808 840.64 499.176C843.616 497.496 847.024 496.656 850.864 496.656C854.608 496.656 857.92 497.472 860.8 499.104C863.68 500.736 865.888 502.992 867.424 505.872C869.008 508.704 869.8 511.92 869.8 515.52ZM863.032 514.152C863.032 511.656 862.48 509.52 861.376 507.744C860.272 505.92 858.76 504.552 856.84 503.64C854.968 502.68 852.88 502.2 850.576 502.2C847.264 502.2 844.432 503.256 842.08 505.368C839.776 507.48 838.456 510.408 838.12 514.152H863.032Z"
              stroke="#63FFCD"
              strokeWidth="1.8"
            />
          </svg>
        </div>

        <div className={`loading-tagline ${showTagline ? "tagline-visible" : ""}`}>
          AUTOMATION LAB
        </div>

        <div className={`loading-subtitle ${showSubtitle ? "subtitle-visible" : ""}`}>
          AI-Powered Enterprise Solutions
        </div>

        <div className="loading-bar-container">
          <div className="loading-bar" />
        </div>
      </div>

      <div className="scan-line" />
    </div>
  );
}

export default LoadingPage;
